import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NotificationService } from '@upr-web-primer/notification';
import { CommonUtilityService } from '../../services/common-utility.service';
@Component({
  selector: 'app-inquiry-confirm',
  templateUrl: './inquiry-confirm.component.html',
  styleUrls: ['./inquiry-confirm.component.scss'],
  standalone: false,
})
export class InquiryConfirmComponent implements OnInit {
  pageLabels: any;
  // @Input() public inquiryForm: FormGroup;
  @Output() backbtn = new EventEmitter<any>();
  disableSendBtn = false;
  inquiryConfTypeArray: { label: any; value: number }[];
  inquiryForm: FormGroup;
  isFormSubmitted: boolean;
  isSubmitting = false;
  constructor(
    private readonly common: CommonUtilityService,
    public notification: NotificationService,
    @Inject('GlobalDefaults') public globalDefault: any,
    @Inject('AppRoutes') public appRoutes: any,
  ) {}

  /**
   * ngOnInit - It will load all the functions
   */
  ngOnInit(): void {
    this.common.getInquiryFormData().subscribe((res: any) => {
      if (res instanceof FormGroup) {
        this.inquiryForm = res;
      }
    });
    this.pageLabels = this.common.getResolvedPageData();
    this.common.scrollTop();
    this.inquiryConfTypeArray = [
      {
        label: this.pageLabels?.['inquiryForm_conf.type_opinions'],
        value: 752510000,
      },
      {
        label: this.pageLabels?.['inquiryForm_conf.type_inquiry'],
        value: 752510001,
      },
      {
        label: this.pageLabels?.['inquiryForm_conf.type_others'],
        value: 752510002,
      },
    ];
  }

  /**
   * inquiryBackBtn - Pass stored data from confirmation page to creation page when user clicks on bak CTA
   */
  inquiryBackBtn(): any {
    this.backbtn.emit({
      inquiryForm: this.inquiryForm,
    });
    this.common.setFormData(this.inquiryForm);
    this.common.changeRoute(this.appRoutes.CONTACT_US);
  }

  /**
   * getSelectedLabel - get the label based on selected value
   * @param value - pass the selected value from  inquiry dropdown
   * @returns
   */
  getSelectedLabel(value: number): string {
    const matchedItem = this.inquiryConfTypeArray.find(
      (item) => item.value === value,
    );
    return matchedItem ? matchedItem.label : '';
  }

  /**
   * onSubmitInquiryCreation - It will submit the formControl to api url
   */
  onSubmitInquiryCreation(): any {
    if (this.isSubmitting) {
      return;
    }
    this.isSubmitting = true;
    const data = this.inquiryForm.value;
    const request = {
      udx_emailaddress: data?.email,
      udx_type: data?.type,
      udx_furiganafirstname: data?.first_name_furgina,
      udx_firstname: data?.firstName,
      udx_surname: data?.lastName,
      udx_furiganasurname: data?.last_name_furgina,
      udx_comments: this.inquiryForm?.get('replyInput')?.value?.trim(),
      udx_acceptedprivacypolicy: data?.agree,
      udx_responserequested: data?.reply === '' || !data?.reply ? true : false,
      udx_phonenumber: data?.phoneNumber,
    };
    this.common
      .postInquiryWebForm(request, this.globalDefault?.CONTACT_US)
      .subscribe(
        () => {
          this.disableSendBtn = true;
          this.isFormSubmitted = true;
          this.common.setFormSubmitted(this.isFormSubmitted);
          this.notification.show(
            this.pageLabels?.['inquiryForm.success'],
            this.globalDefault.SUCCESS,
          );
        },
        () => {
          this.notification.show(this.pageLabels?.['errCode.E019']);
          this.isSubmitting = false;
        },
      );
  }
}
